

export function processForms(base = document) {
    base.querySelectorAll('.wp-block-smarttouch-form > div[data-config]').forEach(el=>{
        let config = LZUTF8.decompress(el.dataset.config,{inputEncoding:'Base64'});
        if(window.attsList) {
            for (const [key, att] of Object.entries(window.attsList)) config = config.replaceAll('[['+key+']]', att);
            config = config.replaceAll(/http\:\/\/http/g,'http');
            config = config.replaceAll(/\[\[.*?\]\]/g, '');
            config = config.replaceAll(/<a /g, '<a target="_blank" ');
        }
        config = JSON.parse(config);
        stFormReady(smarttouch.createForm(config)).then(stForm=>{
            if(config.fields) for(const [field, options] of Object.entries(config.fields)) {
                if(options.value) {
                    let f = stForm.querySelector('input[name="'+field+'"]');
                    if(f) { f.setAttribute('value', options.value); f.value = options.value; }
                    f = stForm.querySelector('option[value="'+options.value+'"]');
                    if(f)  f.setAttribute('selected',true);
                }   
            };
            el.appendChild(stForm);
        });
        el.removeAttribute('data-config');
    });
}

const stFormReady = (stForm) => {
    return new Promise((resolve, reject) => {
        const i = setInterval(()=>{
            if(stForm.querySelector('.stFields')) {
                clearInterval(i);
                resolve(stForm);
            }
        },50);
    });
}